import React, { useContext, useMemo } from 'react';
import { EditModifierContext, IEditModifierContext } from '../../../editModifierState/editModifierContext';
import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import { InputFields } from './components/InputFields';
import { Badge } from 'components/Badge';
import Text from 'components/Text/Text';
import style from './EditForm.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '95:46',
		optimalResolutions: {
			a: '380*184px',
			b: '760*368px',
		},
	},
	vertical: {
		ratio: '44:19',
		optimalResolutions: {
			a: '528*228px',
			b: '1056*456px',
		},
	},
};

export const EditForm: React.FC = () => {
	const { setFileId, deletePhoto, fileId, filePath, modifierID, type, isCreatedOnPos } =
		useContext<IEditModifierContext>(EditModifierContext);

	const loadFromFilePathOptions = useMemo(
		() => ({
			filePath,
			preSignedUrl: null,
			entityID: modifierID,
		}),
		[filePath, modifierID],
	);

	const renderBadges = useMemo(() => {
		if (type || isCreatedOnPos) {
			return (
				<div className={style.badgesWrapper}>
					{type && (
						<Badge color="red">
							<Text
								translationNameSpace="form"
								translationKey={type}
								asFragment={true}
								data-test="modifier"
							/>
						</Badge>
					)}
					{isCreatedOnPos ? (
						<Badge color="purple">
							<Text
								translationKey="POS"
								asFragment={true}
								data-test={`isCreatedOnPos=${isCreatedOnPos}`}
							/>
						</Badge>
					) : (
						<Badge color="purple">
							<Text
								translationKey="AMS"
								asFragment={true}
								data-test={`isCreatedOnPos=${isCreatedOnPos}`}
							/>
						</Badge>
					)}
				</div>
			);
		}
	}, [type, isCreatedOnPos]);

	return (
		<div className={style.container} data-test="EditForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				loadFromFilePathOptions={loadFromFilePathOptions}
				deletePhotoHandler={deletePhoto}
				setFileId={setFileId}
				horizontalAspectRatio={380 / 184}
				verticalAspectRatio={528 / 228}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
				infoContent={renderBadges}
			/>
			<InputFields />
		</div>
	);
};
